let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gudhZ")).then(() => parcelRequire('5nSWq'));